import { dsLogger } from '../../shared/services/logger/logger.instance';

export const toastLogger = dsLogger.extend('toast');
